import React, { useState, useEffect } from "react";
import { useTheme } from '@mui/material/styles';
import {
  Container,
  Box,
  Grid,
  Typography,
  Divider,
  Button,
  Card,
  CardContent,
  IconButton,
  CardMedia,
  Chip,
  Stack,
  Skeleton,
} from "@mui/material";
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { Link, useNavigate } from "react-router-dom";
import autodukan_logo from "../../assets/images/autoducan_logo.png";
import { getUserWishList } from "./../../services/user";
import Featureproduct from "../../components/commenMUI/Featureproduct";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer, } from 'react-toastify';

const HomeSection2 = ({ categorys, product2 }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const loggedIn = localStorage.getItem("is_login");

  const isxlargeScrren = useMediaQuery(theme.breakpoints.up("xl"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const isXsScreen = useMediaQuery(theme.breakpoints.up("xs"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));

  let visibleCategoriesCount = 5;

  if (isXsScreen) {
    visibleCategoriesCount = 5;
  }
  if (isSmallScreen) {
    visibleCategoriesCount = 4;
  }
  if (isMediumScreen) {
    visibleCategoriesCount = 5;
  }
  if (isLargeScreen) {
    visibleCategoriesCount = 5;
  }
  if (isxlargeScrren) {
    visibleCategoriesCount = 6;
  }

  const visiblecategorys = categorys?.slice(0, visibleCategoriesCount);

  const handleClick = (id) => {
    navigate(`/subcategory/${id}`);
  };

  const handleProductClick = (data) => {
    const nav = data.slug !== null ? data.slug : data.id;
    window.open(`/product/${nav}`, '_blank');
  };

  const renderSkeletons = () => {
    const skeletons = [];
    for (let i = 0; i < visibleCategoriesCount; i++) {
      skeletons.push(
        <Grid item key={i}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "2px solid #E0E0E0",
              backgroundColor: "#fff",
              borderRadius: "10px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              width: { xl: "185px", lg: "190px", md: "150px", sm: "150px", xs: "190px" },
              height: { lg: "180px", md: "150px", sm: "150px", xs: "204px" },
              overflow: 'hidden',
              justifyContent: "sapce-between",
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "80%",
                position: "relative",
                overflow: "hidden",
                borderRadius: "8px",
                backgroundColor: "#f0f0f0",
                '&::before': {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  // background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                  // animation: "shimmer 1.5s infinite",
                  backgroundSize: "200% 100%",
                },
              }}
            >
              <Skeleton
                variant="rectangular"
                width="80%"
                height="80%"
              />
            </Box>
            <Box sx={{ width: "100%", textAlign: "center", marginTop: "8px" }}>
              <Skeleton
                variant="text"
                width="60%"
                sx={{
                  height: "20px",
                  margin: "0 auto",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                }}
              />
            </Box>
          </Box>
        </Grid>
      );
    }
    return skeletons;
  };


  return (
    <>
      <Box
        alignContent={"center"}
        paddingTop={{ lg: "80px", xs: "35px" }}
        paddingBottom={{ lg: "90px", xs: "40px" }}
        sx={{
          backgroundColor: "rgba(246, 246, 246, 1)",
        }}
      >
        <Grid
          fluid="true"
          maxWidth={{ xl: "1303px", lg: "1103px", xs: undefined, md: "900px", sm: "800px" }}
          margin="auto"
          sx={{
            padding: { lg: "0px", md: "0px", sm: "10px", xs: "10px" }
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box display={"flex"}>
              <h2
                className="title_name1"
                style={{
                  margin: "0px",
                  textTransform: "uppercase",
                  borderRadius: "10px",
                  fontWeight: 500,
                  lineHeight: "30px",
                  fontFamily: "'Bebas Neue', sans-serif"
                }}
              >
                Shop By categories
              </h2>
            </Box>

            <Box>
              <Link to={"/category"}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardOutlinedIcon style={{ fontSize: '15px' }} />}
                  sx={{
                    backgroundColor: "rgba(255, 102, 51, 1)",
                    fontFamily: "'Barlow', sans-serif",
                    textTransform: "none",
                    borderRadius: "5px",
                    width: { lg: "129px", xs: "110px", sm: "121px", md: "121px" },
                    fontSize: { lg: "19px", xs: "17px", sm: "19px", md: "19px" },
                    height: { lg: "41px", xs: "30px", sm: "33px", md: "35px" },
                    "&:hover": {
                      backgroundColor: "rgba(255, 102, 51, 1)",
                      color: "#fff",
                    },
                  }}
                >
                  View all
                </Button>
              </Link>
            </Box>
          </Box>
          <Box sx={{ overflowX: 'auto' }}>
            <Grid
              container
              spacing={{ sm: 0, xs: 2 }}
              sx={{
                pt: "50px",
                flexWrap: 'nowrap',
                '@media (min-width: 600px)': {
                  flexWrap: 'wrap',
                },
                justifyContent: "space-between",
                gap: 2
              }}
            >
              {(!categorys || categorys.length === 0) ? renderSkeletons() :
                visiblecategorys.map((category, index) => (
                  <Grid item key={index}>
                    <Box
                      onClick={() => handleClick(category.slug)}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        border: "2px solid #E0E0E0",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        cursor: "pointer",
                        width: { xl: "185px", lg: "190px", md: "150px", sm: "150px", xs: "190px" },
                        height: { lg: "180px", md: "150px", sm: "150px", xs: "204px" },
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        justifyContent: "center",
                      }}
                    >
                      <Box style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }} >
                        <img
                          loading="lazy"
                          src={category.image ? category.image : autodukan_logo}
                          alt={category.name}
                          style={{ width: "100%", height: "auto", objectFit: 'contain' }}
                        />
                      </Box>
                      <Box>
                        <Typography
                          variant="h3"
                          sx={{
                            fontFamily: "'Bebas Neue', sans-serif",
                            fontWeight: 500,
                            fontSize: { lg: "20px", sm: "14px", xs: "20px" },
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical'
                          }}
                        >
                          {category.name}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))
              }
            </Grid>
          </Box>
        </Grid>
      </Box>

      <Grid
        fluid="true"
        maxWidth={{ xl: "1303px", lg: "1103px", xs: undefined, md: "900px", sm: "800px" }}
        margin="auto"
        sx={{
          padding: { lg: "0px", md: "0px", sm: "10px", xs: "10px" }
        }}
      >
        <Box
          alignContent={"center"}
          sx={{
            marginTop: { lg: "80px", xs: "50px" },
            mb: { lg: "80px", xs: "50px" }
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: { lg: "0px", md: "29px", xs: "20px" },
              alignItems: "center",
            }}
          >
            <Box display={"flex"} >
              <h2
                className="title_name1"
                style={{
                  margin: "0px",
                  textTransform: "uppercase",
                  borderRadius: "10px",
                  fontWeight: 500,
                  lineHeight: "30px",
                  fontFamily: "'Bebas Neue', sans-serif"
                }}
              >
                Featured Product List
              </h2>
            </Box>

            <Box>
              <Link to={"/featured-product"}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardOutlinedIcon style={{ fontSize: '15px' }} />}
                  sx={{
                    backgroundColor: "rgba(255, 102, 51, 1)",
                    fontFamily: "'Barlow', sans-serif",
                    textTransform: "none",
                    borderRadius: "5px",
                    width: { lg: "129px", xs: "110px", sm: "121px", md: "121px" },
                    fontSize: { lg: "19px", xs: "17px", sm: "19px", md: "19px" },
                    height: { lg: "41px", xs: "30px", sm: "33px", md: "35px" },
                    "&:hover": {
                      backgroundColor: "rgba(255, 102, 51, 1)",
                      color: "#fff",
                    },
                  }}
                >
                  View All
                </Button>
              </Link>
            </Box>
          </Box>

          <Featureproduct
            handleProductClick={handleProductClick}
            product2={product2}
          />
        </Box>
      </Grid>
    </>
  );
};

export default HomeSection2;